import {FormBase} from '../../components/formsBase/formBase';

/**
 * React functional component representing the HeHealth Base.
 * @component
 * @param {Object} props - The component's properties.
 * @param {React.ReactNode} props.children - The child elements to be rendered within the component.
 * @param {number} props.formProgress - The progress value for the form.
 * @returns {JSX.Element} The rendered MensSexualHealthBase component.
 */
export const MensSexualHealthBase = ({children, formProgress, ...props}) => {
  return (
    <FormBase
      {...props}
      useCurrentPageProgress
      {...(formProgress === undefined ? {} : {currentPageProgress: formProgress})}
      pageNames={['Start', 'Details', 'Results']}
    >
      {children}
    </FormBase>
  );
};
